/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Tour_Dashboard_BodyInputs */



/**
* | output |
* | --- |
* | "Your overview: recent activity, usage and shortcuts into your work." |
*
* @param {Onboarding_Tour_Dashboard_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_dashboard_body = /** @type {((inputs?: Onboarding_Tour_Dashboard_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Dashboard_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dein Überblick: letzte Aktivität, Nutzung und Abkürzungen in deine Arbeit.")
	return /** @type {LocalizedString} */ ("Your overview: recent activity, usage and shortcuts into your work.")
});